var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTalIconActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.5 6.5h-.521A6.01 6.01 0 0 0 7.5 1.021V.5a.5.5 0 0 0-1 0v.521A6.01 6.01 0 0 0 1.021 6.5H.5a.5.5 0 0 0 0 1h.521A6.01 6.01 0 0 0 6.5 12.979v.521a.5.5 0 0 0 1 0v-.521A6.01 6.01 0 0 0 12.979 7.5h.521a.5.5 0 0 0 0-1m-2 1h.475A5.01 5.01 0 0 1 7.5 11.975V11.5a.5.5 0 0 0-1 0v.475A5.01 5.01 0 0 1 2.025 7.5H2.5a.5.5 0 1 0 0-1h-.475A5.01 5.01 0 0 1 6.5 2.025V2.5a.5.5 0 1 0 1 0v-.475A5.01 5.01 0 0 1 11.975 6.5H11.5a.5.5 0 0 0 0 1m-2-.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
})));
export { SvgTalIconActive as ReactComponent };
export default __webpack_public_path__ + "b280fefbc9bb205ff234c84b444f0d8f.svg";